import { render, staticRenderFns } from "./PlanAdhesionPlanDocuments.vue?vue&type=template&id=3b46bcc1"
import script from "./PlanAdhesionPlanDocuments.vue?vue&type=script&lang=js"
export * from "./PlanAdhesionPlanDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports